var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    {
      staticClass:
        "align-items-center document-request-collapse bg-white no-outline border-top",
      attrs: { "no-gutters": "" },
    },
    [
      _c(
        "b-col",
        { attrs: { md: "4", col: "" } },
        [
          _c(
            "b-row",
            { staticClass: "align-items-center", attrs: { "no-gutters": "" } },
            [
              _c(
                "b-col",
                {
                  staticClass: "d-none d-sm-flex",
                  attrs: { cols: "1", md: "2", lg: "1" },
                },
                [
                  _c(
                    "span",
                    {
                      staticClass:
                        "dropdown-item-drag-handle cursor-move d-none d-sm-flex align-items-center mr-2",
                    },
                    [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v(" menu "),
                      ]),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass: "d-flex flex-row align-items-center",
                  attrs: { cols: "2", sm: "1", md: "2", lg: "1" },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                    },
                  },
                },
                [
                  _c("div", { staticClass: "pretty p-icon p-smooth m-0" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.documentMarked,
                          expression: "documentMarked",
                        },
                      ],
                      staticClass: "valid request-checkmark",
                      attrs: {
                        id: _vm.labelValue1,
                        name: "request",
                        type: "checkbox",
                      },
                      domProps: {
                        checked: Array.isArray(_vm.documentMarked)
                          ? _vm._i(_vm.documentMarked, null) > -1
                          : _vm.documentMarked,
                      },
                      on: {
                        change: function ($event) {
                          var $$a = _vm.documentMarked,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                (_vm.documentMarked = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.documentMarked = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.documentMarked = $$c
                          }
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "state p-primary" }, [
                      _c(
                        "i",
                        {
                          staticClass: "icon material-icons small-icon",
                          staticStyle: { "font-size": "1em !important" },
                        },
                        [_vm._v("done")]
                      ),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "text-light-gray hidden-text",
                          attrs: { for: _vm.labelValue1 },
                        },
                        [_vm._v(_vm._s(_vm.$t("global.words.select")))]
                      ),
                    ]),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { cols: "10", md: "8", lg: "10" } },
                [
                  _c(
                    "b-row",
                    {
                      staticClass:
                        "align-items-center font-sm btn-link flex-nowrap",
                      attrs: { "no-gutters": "" },
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass:
                            "button-collapse-description mb-0 text-truncate un-selectable text-capitalize",
                          attrs: { title: _vm.classificationName },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.classificationName) +
                              " \n          "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("b-col", { attrs: { cols: "auto" } }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "font-weight-bold d-flex flex-row align-items-center",
                          },
                          [
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "b-tooltip",
                                    rawName: "v-b-tooltip",
                                    value: _vm.counterTooltipText,
                                    expression: "counterTooltipText",
                                  },
                                ],
                                staticClass:
                                  "pr-1 d-flex flex-row align-items-center",
                              },
                              [
                                _vm._v("\n                (\n                "),
                                _c("span", { class: _vm.counterClass }, [
                                  _vm._v(
                                    _vm._s(_vm.completedDocuments) +
                                      "/" +
                                      _vm._s(_vm.totalDocuments) +
                                      "\n                "
                                  ),
                                ]),
                                _vm._v(" "),
                                _vm.totalDocuments &&
                                _vm.completedDocuments === _vm.totalDocuments
                                  ? _c("icon", {
                                      staticClass: "text-success ml-1",
                                      attrs: { name: "check" },
                                    })
                                  : _vm._e(),
                                _vm._v("\n                )\n              "),
                              ],
                              1
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("icon", {
                        attrs: {
                          name: _vm.visible ? "caret-down" : "caret-right",
                        },
                      }),
                      _vm._v(" "),
                      _vm.visibleStatuses.length
                        ? _c("b-col", { attrs: { cols: "auto" } }, [
                            _c(
                              "div",
                              { staticClass: "d-flex align-items-center ml-2" },
                              _vm._l(_vm.visibleStatuses, function (ref) {
                                var icon = ref.icon
                                var status = ref.status
                                return _c("i", {
                                  directives: [
                                    {
                                      name: "b-tooltip",
                                      rawName: "v-b-tooltip",
                                      value: {
                                        title: _vm.$t(
                                          "documents.status." + status
                                        ),
                                      },
                                      expression:
                                        "{ title: $t(`documents.status.${status}`) }",
                                    },
                                  ],
                                  key: status,
                                  class: icon + " ml-2",
                                })
                              }),
                              0
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.sent
                        ? _c("b-col", { attrs: { cols: "auto" } }, [
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "b-tooltip",
                                    rawName: "v-b-tooltip",
                                    value: _vm.$t(
                                      "documents.requestSentViaEmail",
                                      {
                                        requestedAt: _vm.requestedAt
                                          ? _vm.$t("documents.onDate", {
                                              date: _vm.formattedRequestedAt,
                                            })
                                          : "",
                                      }
                                    ),
                                    expression:
                                      "\n                $t('documents.requestSentViaEmail', {\n                  requestedAt: requestedAt\n                    ? $t('documents.onDate', { date: formattedRequestedAt })\n                    : ''\n                })\n              ",
                                  },
                                ],
                                staticClass: "ml-3",
                              },
                              [_c("icon", { attrs: { name: "envelope" } })],
                              1
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.totalNewComments
                        ? _c("b-col", { attrs: { cols: "auto" } }, [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "text-primary clickable text-truncate ml-2",
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$tc(
                                        "documents.newComment",
                                        _vm.totalNewComments,
                                        {
                                          number: _vm.totalNewComments,
                                        }
                                      )
                                    ) +
                                    "!\n            "
                                ),
                              ]
                            ),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-col",
        {
          staticClass: "d-md-block d-none",
          attrs: { cols: "4", md: "5", lg: "6" },
        },
        [
          _c("editable-description", {
            attrs: {
              loading: _vm.savingDescription,
              description: _vm.description,
              "noa-issue": _vm.noaIssue,
            },
            on: { save: _vm.handleSaveDescription },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-col",
        {
          staticClass:
            "actions-section d-flex align-items-center justify-content-end",
          attrs: { cols: "auto", md: "3", lg: "2" },
        },
        [
          !_vm.showDropzone
            ? [
                _c(
                  "div",
                  {
                    staticClass: "text-right",
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                      },
                    },
                  },
                  [
                    _vm.uploadingDocuments
                      ? _c(
                          "span",
                          {
                            staticClass:
                              "btn request-from-type text-primary bold text-right d-flex flex-row align-items-center",
                          },
                          [
                            _c("inline-loader", { staticClass: "mr-1" }),
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.$t("global.words.uploading")) +
                                "...\n        "
                            ),
                          ],
                          1
                        )
                      : _c(
                          "a",
                          {
                            staticClass:
                              "btn request-from-type clickable text-primary bold text-right mr-3",
                            on: {
                              click: function ($event) {
                                return _vm.$refs.fileInput.click()
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.$t("global.words.upload")) +
                                "\n        "
                            ),
                          ]
                        ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "b-tooltip",
                        rawName: "v-b-tooltip",
                        value: _vm.tooltipOptions,
                        expression: "tooltipOptions",
                      },
                    ],
                    attrs: { tabindex: "0" },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                      },
                    },
                  },
                  [
                    _c(
                      "inline-prompt",
                      {
                        staticClass: "d-inline-block",
                        attrs: {
                          "confirmation-text": _vm.$t(
                            "documents.deleteDocumentTypeConfirmation"
                          ),
                          placement: "left",
                          disabled: !!_vm.totalDocuments,
                        },
                        on: { accept: _vm.handleDeleteDocumentClassification },
                      },
                      [
                        _c("icon", {
                          class: {
                            "disabled text-light-gray": _vm.totalDocuments,
                            "text-danger": !_vm.totalDocuments,
                          },
                          attrs: { name: "trash" },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            : _c("div", [
                _vm.uploadingDocuments
                  ? _c(
                      "span",
                      {
                        staticClass:
                          "btn request-from-type text-primary bold text-right d-flex flex-row align-items-center",
                      },
                      [
                        _c("inline-loader", { staticClass: "mr-1" }),
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.$t("global.words.uploading")) +
                            "...\n      "
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
          _vm._v(" "),
          _c("input", {
            ref: "fileInput",
            staticStyle: { display: "none" },
            attrs: {
              id: _vm.labelValue2,
              type: "file",
              accept:
                "application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/msword,image/png,image/tiff,image/jpeg",
              multiple: "",
            },
            on: {
              change: _vm.handleFilesSelected,
              click: function ($event) {
                $event.stopPropagation()
              },
            },
          }),
          _vm._v(" "),
          _c(
            "label",
            { staticClass: "hidden-text", attrs: { for: _vm.labelValue2 } },
            [_vm._v(_vm._s(_vm.$t("client-profile.actions.uploadFiles")))]
          ),
        ],
        2
      ),
      _vm._v(" "),
      _vm.showDropzone || !_vm.isFileEmpty
        ? _c("b-col", [
            _c(
              "div",
              {
                staticClass: "mb-2 px-3",
                style: { border: "1.8px dashed #777" },
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _vm.$refs.fileInput.click()
                  },
                },
              },
              [
                _c("p", { staticClass: "text-center small" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.$t("documents.uploadDocumentTo", {
                          name: _vm.classificationName,
                        })
                      ) +
                      "\n      "
                  ),
                ]),
                _vm._v(" "),
                !_vm.isFileEmpty
                  ? [
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex justify-content-center text-center text-light-gray",
                        },
                        _vm._l(_vm.files, function (ref, index) {
                          var name = ref.name
                          var size = ref.size
                          var upload = ref.upload
                          return _c(
                            "div",
                            {
                              key: upload ? upload.uuid : index,
                              staticClass: "p-3 mr-2",
                            },
                            [
                              _c("span", { staticClass: "small" }, [
                                _vm._v(_vm._s(_vm.getFileSize(size)) + "MB"),
                              ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "small" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(name) +
                                    "\n            "
                                ),
                              ]),
                            ]
                          )
                        }),
                        0
                      ),
                    ]
                  : _vm._e(),
              ],
              2
            ),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }